@if (data$ | async; as data) {
  <cx-generic-link [routerLink]="data.urlLink" [target]="getTarget(data)">
  </cx-generic-link>
  @if (data.media && (data.media.widescreen || data.media.mobile)) {
    <a [routerLink]="data.urlLink">
      <cx-media [container]="(isMobile() | async) ? data.media.mobile : data.media.widescreen"
      [class]="data.positionText === 'true' ? 'img-opacity' : 'img-inherit'"></cx-media>
    </a>
  } @else {
    <cx-media [container]="data.media"
    [class]="data.positionText === 'true' ? 'img-opacity' : 'img-inherit'"></cx-media>
  }
  <div [class]="data.positionText === 'true' ? 'wrapper-absolute' : 'wrapper-inherit'">
    @if (data.headline) {
      @switch (data.titleTag) {
        @case ('H1') {
          <h1
            class="headline"
            [style.color]="data.colorText"
            [innerHTML]="data.headline"
          ></h1>
        }
        @case ('H2') {
          <h2
            class="headline"
            [style.color]="data.colorText"
            [innerHTML]="data.headline"
          ></h2>
        }
        @default {
          <p
            class="headline"
            [style.color]="data.colorText"
            [innerHTML]="data.headline"
          ></p>
        }
      }
    }
    @if (data.content) {
      <p
        class="content {{data.buttonText ? '' : 'no-button'}}"
        [style.color]="data.colorText"
        [style.font-size]="data.sizeText"
        [style.font-weight]="data.boldText ? 'bold' : '400'"
        >
        {{data.content}}
      </p>
    }
    @if (data.buttonText) {
      <a
        [routerLink]="data.urlLink"
        class="btn main-banner-button"
        [style.color]="data.colorTextButton"
        [style.background-color]="data.backgroundButton"
        [style.font-size]="data.sizeTextButton"
        [style.font-weight]="data.boldTextButton ? 'bold' : '400'"
        >
        {{data.buttonText}}
      </a>
    }
  </div>
}
